import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import Brand from "@/components/Brand";
import { ArrowLeft } from "lucide-react";
import api, { extractErr } from "@/lib/api";

export default function MerchantForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/password/request-reset", { email, kind: "merchant" });
      setSent(true);
    } catch (err) {
      toast.error(extractErr(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <Link to="/login" className="flex items-center gap-2 text-sm text-slate-400 hover:text-white mb-8" data-testid="forgot-back">
          <ArrowLeft className="w-4 h-4" /> Back to sign in
        </Link>
        <div className="mb-6"><Brand variant="dark" size="md" /></div>
        <h1 className="font-display text-3xl font-bold">Reset your password</h1>
        <p className="text-slate-400 text-sm mt-1">We'll email you a secure link to set a new password.</p>

        {sent ? (
          <div className="mt-8 p-5 rounded-xl bg-emerald-500/10 border border-emerald-500/30 text-emerald-100" data-testid="forgot-sent">
            <div className="font-semibold">Check your inbox</div>
            <div className="text-sm text-emerald-200/80 mt-1">If an account exists for <span className="font-mono-nums">{email}</span>, a reset link is on its way. It expires in 60 minutes.</div>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <Label className="text-slate-300">Email</Label>
              <Input required type="email" data-testid="forgot-email" className="bg-slate-900 border-slate-700 text-white mt-1" value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <Button type="submit" disabled={loading} data-testid="forgot-submit" className="w-full h-11 bg-orange-500 hover:bg-orange-600 text-slate-900 font-semibold rounded-full">
              {loading ? "Sending…" : "Send reset link"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
